import React from 'react';
import SearchInput from '../SearchInput';
import { producaov2 } from '../../../../../services/apis';

const blockingReasonRequest = async (search) => {
  const response = await producaov2.get(`admin/blocking-reasons?search=${search}&limit=25`);
  return response.data?.map(reason => ({id: reason?.id, name: `${reason?.name}`}));
}

export default function BlockingReasonSearch({name, selectedBlockingReason, onChangeSelectedBlockingReason, errorMessage }) {
  return (
    <SearchInput
      name={name}
      loadWhenEmpty
      label="Selecione um motivo de bloqueio"
      searchRequest={blockingReasonRequest}
      selectedOption={selectedBlockingReason}
      onChangeSelectedOption={onChangeSelectedBlockingReason}
      errorMessage={errorMessage}
      helperText="Contate TI caso seja necessário outro motivo de bloqueio"
    />
  );
}